<template>
  <div class="card shadow" v-on:click="select">
    <img  :src="domain.logo" class="images">
    <div class="card-text">
      <span>{{ domain.tenantName }}</span>
      <span>{{ domain.domain }}</span>
    </div>
  </div>
</template>

<script>

export default {
  props: [
    "domain" // domain OBJECT
  ],
  data() {
    return {
      nothing: ""
    };
  },
  computed: {
  },
  methods: {
    select() {
      this.$emit("selectDomain", this.domain.domain);
    }
  }
};
</script>

<style lang="scss" scoped>

/*******
  #TENANT-CARD
 */

  .card {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 210px; // Increased to ensure domain name fits on wide screens
    padding: .5em;
    border: 2px white solid;
    border-radius:1em;
    text-align:center;
    margin: 0;
    transition:all 0.3s ease;
    box-sizing: border-box;
    overflow: visible; // Allow content to be visible

    img {
     padding:.25em;
     max-width: 75%; // Reduced to give more room for text
     max-height:50%; // Reduced to ensure text fits
     object-fit:contain; // Ensure logo fits within constraints
     flex-shrink: 0;
     margin: 0 auto; // Center the image
     display: block; // Ensure centering works
    }

    .card-text {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: flex-start; // Align to top to ensure space for domain
      padding-top: .25em;
      min-height: 0; // Allow flex shrinking
      overflow: visible; // Allow text to be fully visible
      width: 100%; // Constrain width
      
      span:first-child {
        font-size: 1.1em;
        font-weight: 600;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        line-height: 1.2;
        margin-bottom: .25em;
        text-shadow: -2px 2px 4px rgba(163,163,163,0.4);
        word-break: break-word;
        max-width: 100%;
      }
      span:nth-child(2)::before {
        white-space:pre;
        content: "\A";
      }
      span:nth-child(2) {
        border-top:1px solid lightgray;
        font-style:italic;
        color:lightgray;
        font-size: 0.8em;
        line-height: 1.3;
        padding-top: .25em;
        margin-top: .2em;
        overflow: visible; // Ensure domain is visible
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 100%;
        min-height: 1.4em; // Ensure minimum height for domain text
      }
    }
  }

  .card:hover {
    border: 2px gray solid;
    /*border-radius:1em;*/
    /*margin:0;*/
    background:#f0f0f0;
    opacity:1;
    box-shadow: inset 0 0 0 5px gray;
    -webkit-transform: rotateZ(-3deg);
    -ms-transform: rotateZ(-3deg);
    transform: rotateZ(-3deg);
  }

  // Responsive styles for narrow screens
  @media (max-width: 767px) {
    .card {
      height: 220px; // Even taller to ensure domain name fits completely
      padding: .4em .25em;
      overflow: visible; // Allow content to be visible
    }

    img {
      max-width: 45%; // Smaller icon to give more room for text
      max-height: 32%; // Further reduce icon height to make more room for text
      padding: .1em;
      flex-shrink: 0;
      margin: 0 auto; // Center the image
      display: block; // Ensure centering works
      object-fit: contain; // Ensure logo fits within constraints
    }

    .card-text {
      padding-top: .15em;
      flex: 1;
      min-height: 0;
      overflow: visible; // Allow text to be fully visible
      width: 100%; // Constrain width
      display: flex;
      flex-direction: column;
      justify-content: flex-start; // Align to top to ensure space for domain
      
      span:first-child {
        font-size: 0.75em; // Readable text size
        font-weight: 600;
        line-height: 1.2;
        margin-bottom: .25em;
        text-shadow: -1px 1px 2px rgba(163,163,163,0.3);
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        word-break: break-word;
        max-width: 100%;
      }
      span:nth-child(2) {
        font-size: 0.65em; // Readable domain text
        line-height: 1.4;
        padding-top: .3em;
        margin-top: .25em;
        overflow: visible; // Ensure domain is visible
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 100%;
        min-height: 1.6em; // Ensure minimum height for domain text
      }
    }
  }

  @media (max-width: 480px) {
    .card {
      height: 210px; // Even taller for single column to ensure domain name fits
      padding: .35em .2em;
      overflow: visible; // Allow content to be visible
    }

    img {
      max-width: 42%; // Smaller icon
      max-height: 30%; // Further reduce icon height to make more room for text
      padding: .08em;
      flex-shrink: 0;
      margin: 0 auto; // Center the image
      display: block; // Ensure centering works
      object-fit: contain; // Ensure logo fits within constraints
    }

    .card-text {
      padding-top: .15em;
      flex: 1;
      min-height: 0;
      overflow: visible; // Allow text to be fully visible
      width: 100%; // Constrain width
      display: flex;
      flex-direction: column;
      justify-content: flex-start; // Align to top to ensure space for domain
      
      span:first-child {
        font-size: 0.7em; // Readable text size
        font-weight: 600;
        line-height: 1.2;
        margin-bottom: .2em;
        text-shadow: -1px 1px 2px rgba(163,163,163,0.3);
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        word-break: break-word;
        max-width: 100%;
      }
      span:nth-child(2) {
        font-size: 0.6em; // Readable domain text
        line-height: 1.4;
        padding-top: .25em;
        margin-top: .2em;
        overflow: visible; // Ensure domain is visible
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 100%;
        min-height: 1.6em; // Ensure minimum height for domain text
      }
    }
  }

</style>
